
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../shared/auth.service';
import { HospitalService } from '../shared/hospital.service';
import { environment } from "../../environments/environment";

declare var $ : any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public state = "login";
  guId: string;
  login: any;
  forgotPassword: any;
  recoveryPassword: any;
  isLoading = false;
  isError = false;
  message = "";

  isResetError: boolean;
  isChangePwdError: boolean;
  resetMessage = "";

  success_sent: boolean = false;

  login_spinner: boolean = false;

  token_check: any = null;
  alliance_check: any = null;
  his_ui : string;
  constructor(    
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private hospitalService: HospitalService,) { 
    this.his_ui = environment.his_ui;

    }

  async ngOnInit() {

    this.route.params.subscribe(async params => {
      this.guId = params["guid"];
      // console.log(this.guId);
      if (this.guId) {
        this.state = "reset-password";
      }
    });
      let token = null;
      let allianceData = null;
      let userAllianceData = null;
      let ref = this;
      
      const tokenURL = await this.hospitalService.getTokenFromURL().then(res => {
        token = res;
      });
      if(token) {
        ref.authService.setToken(token);
        const allianceResponse = await ref.hospitalService.getAlliance().then(result => {
          allianceData = result;
        });
        if(allianceData) {
          localStorage.setItem("alliance",JSON.stringify(allianceData));
        }

        const userAllianceResponse = await ref.hospitalService.getUserAlliance().then(result => {
          userAllianceData = result;
        });
        if(userAllianceData) {
          localStorage.setItem("user_alliance",JSON.stringify(userAllianceData));
        }
        
      }
         this.token_check = localStorage.getItem('token');
            if(this.token_check) {
              if (this.token_check && !this.authService.isTokenExpired()) {
                this.alliance_check = localStorage.getItem('alliance');
                if (this.alliance_check) {
                  this.alliance_check = JSON.parse(this.alliance_check);
                  alert('Redirecting back to app');
                  ref.authService.setToken(this.token_check);
                  if (this.alliance_check.organization.type == 1) {
                    document.location.href =  this.his_ui ? this.his_ui : '/his';
                  } else if (this.alliance_check.organization.type == 2) {
                    document.location.href = '/pharmacy/product';
                  } else if (this.alliance_check.organization.type == 3) {
                    document.location.href = '/radiology/dashboard';
                  } else if (this.alliance_check.organization.type == 4) {
                    document.location.href = '/laboratory';
                  } else if (this.alliance_check.organization.type == 5) {
                    document.location.href = '/tpa/mail-client';
                  } else if (this.alliance_check.organization.type == 7) {
                    document.location.href =  this.his_ui ? this.his_ui : '/his';
                  } else if (this.alliance_check.organization.type == 8) {
                    document.location.href = '/pharmacy/product';
                  }
                }
              }
            } 
  }

  openLogin(){
    $('#login-form').modal('show');
  }


  openDemo(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Demo Request');
  }

  openContact(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Contact Us');
  }

  collapseNav(){
    $('.navbar-toggler').click();
    this.hideMenuOnLeave();
  }

  showMenuOnHover(){
    $(`#companyDropdown`).attr('style', 'display: block');
  }
  
  hideMenuOnLeave(){
    $(`#companyDropdown`).attr('style', 'display: none');
  }
}
